import React from 'react'
import Container from '@material-ui/core/Container'
import styleClasses from '../components/common/common.module.scss'
import NotificationsList from '../components/notifications/NotificationsList'
import { useGetUserInfo } from '../hooks/useGetUserInfo'
import { useIsSecurityUser } from '../hooks/useIsSecurityUser'
export default function CommunicationsPage() {
  const isSecurityUser = useIsSecurityUser()
  const userInfo = useGetUserInfo()

  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        {isSecurityUser && userInfo?.building && (
          <NotificationsList building={userInfo?.building} />
        )}
        {!isSecurityUser && <NotificationsList />}
      </Container>
    </main>
  )
}
